import Vue from 'vue';
import Programmes from '../vue/Programmes.vue';


export default {
  init() {
    // JavaScript to be fired on the digital page
    console.log('digitalPort');
    new Vue({
      el: '#digitalport',
      components: {
        Programmes,
      },
      data: {
        message: 'Hello Vue!',
      },
    })


  },
};



// WEBPACK FOOTER //
// ./scripts/routes/digitalPort.js